module.exports = __webpack_public_path__ + "static/img/savings.bed2234.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/savings.svg
// module id = Z249
// module chunks = 0